import { createTheme } from "@material-ui/core/styles";

const fontSize1 = "0.75rem";
const fontSize2 = "0.875rem";

const AssetTheme = createTheme({
  palette: {
    primary: {
      main: "rgb(2, 47, 64)",
    },
  },
  props: {
    MuiSvgIcon: {
      fontSize: "small",
    },
    MuiIconButton: {
      color: "primary",
    },
    MuiButton: {
      disableElevation: true,
    },
  },
  overrides: {
    MuiTextField: {
      root: {
        margin: ".25rem 0 0 .25rem",
      },
    },
    MuiInput: {
      input: {
        fontSize: fontSize1,
        padding: "0 .5rem .5rem 0",
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: fontSize2,
      },
      shrink: {
        color: "#000000 !important",
      },
    },
    MuiIconButton: {
      root: {},
      colorPrimary: {
        "&:hover": {
          backgroundColor: "#d3f0f0",
        },
      },
      colorSecondary: {
        "&:hover": {
          backgroundColor: "#d3f0f0",
        },
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: fontSize2,
        color: "#000000",
      },
    },
    MuiFormControlLabel: {
      root: {
        marginBottom: 0,
      },
      label: {
        fontSize: fontSize1,
        textAlign: "justify",
      },
    },
    MuiTypography: {
      body1: {
        fontSize: fontSize1,
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
      },
    },
  },
});

export default AssetTheme;
